const urlsByEnv = {
  prod: {
    static: 'https://dashboard.p1.neustar.biz',
    dap: 'https://dap-api.p1.neustar.biz/activation_dap/api',
    act: 'https://activation-api.p1.neustar.biz/activation/api',
    audience: 'https://audience-api.p1.neustar.biz/audience/api',
    dqsBaseUrl: 'https://dqs.p1.neustar.biz',
    legacyDomain: 'https://classic.p1.neustar.biz',
    mgmt: 'https://management-api.p1.neustar.biz/management/api',
    neuakApiBaseUrl: 'https://ui-api.p1.neustar.biz/neuak/api',
    onboardingPortalUrl: 'https://onboardingportal.neustar.biz',
    provisioning: 'https://activation-api.p1.neustar.biz/provisioning/api',
  },

  qa: {
    static: 'https://mip.gp.agkn.net',
    dap: 'https://dap-api-qa-gp-dca.gp.agkn.net/activation_dap/api',
    act: 'https://activation-api-qa-gp-dca.gp.agkn.net/activation/api',
    audience: 'https://audience-api-qa-gp-dca.gp.agkn.net/audience/api',
    dqsBaseUrl: 'https://dqs-qa-dca.gp.agkn.net',
    legacyDomain: 'https://classic-qa-dca.gp.agkn.net',
    mgmt: 'https://management-api-qa-dca.gp.agkn.net/management/api',
    neuakApiBaseUrl: 'https://ui-api-qa-dca.gp.agkn.net/neuak/api',
    onboardingPortalUrl: 'https://onboarding-test.gp.agkn.net',
    provisioning: 'https://activation-api-qa-gp-dca.gp.agkn.net/provisioning/api',
  },

  idmp: {
    static: 'https://mip-qa.idmp.agkn.net',
    dap: 'https://dap-api-qa-dca.idmp.agkn.net/activation_dap/api',
    act: 'https://activation-api-qa-dca.idmp.agkn.net/activation/api',
    audience: 'https://audience-api-qa-dca.idmp.agkn.net/audience/api',
    dqsBaseUrl: 'https://dqs-qa-dca.idmp.agkn.net',
    legacyDomain: 'https://classic-qa-dca.idmp.agkn.net',
    mgmt: 'https://management-api-qa-dca.idmp.agkn.net/management/api',
    neuakApiBaseUrl: 'https://ui-api-qa-dca.idmp.agkn.net/neuak/api',
    onboardingPortalUrl: 'https://onboarding-test.idmp.agkn.net',
    provisioning: 'https://activation-api-qa-dca.idmp.agkn.net/provisioning/api',
  },


  dev: {
    static: 'https://mip.dev.agkn.net',
    dap: 'https://dap-api-dev-dca.dev.agkn.net/activation_dap/api',
    //dap: 'https://local.dev.agkn.net:8644/activation-dap/api',
    act: 'https://activation-api-dev-dca.dev.agkn.net/activation/api',
    audience: 'https://audience-api-dev-dca.dev.agkn.net/audience/api',
    dqsBaseUrl: 'https://dqs-dev-dca.dev.agkn.net',
    legacyDomain: 'https://classic-dev-dca.dev.agkn.net',
    mgmt: 'https://management-api-dev-dca.dev.agkn.net/management/api',
    neuakApiBaseUrl: 'https://ui-api-dev-dca.dev.agkn.net/neuak/api',
    onboardingPortalUrl: 'https://onboarding-dev.dev.agkn.net',
    provisioning: 'https://activation-api-dev-dca.dev.agkn.net/provisioning/api'
  },

  local:  {
    static: 'https://local.p1.neustar.biz:3003/',
    // static: 'https://local.dev.agkn.net:3003',
    dap: 'https://dap-api-dev-dca.dev.agkn.net/activation_dap/api',
    //dap: 'https://local.dev.agkn.net:8644/activation-dap/api',
    act: 'https://activation-api-dev-dca.dev.agkn.net/activation/api',
    audience: 'https://audience-api-dev-dca.dev.agkn.net/audience/api',
    dqsBaseUrl: 'https://dqs-dev-dca.dev.agkn.net',
    legacyDomain: 'https://classic-dev-dca.dev.agkn.net',
    mgmt: 'https://management-api-dev-dca.dev.agkn.net/management/api',
    neuakApiBaseUrl: 'https://ui-api-dev-dca.dev.agkn.net/neuak/api',
    onboardingPortalUrl: 'https://onboarding-dev.dev.agkn.net',
    provisioning: 'https://activation-api-dev-dca.dev.agkn.net/provisioning/api'
  },
};

const URLS = (() => {
  let hostname = typeof window === 'undefined' ? '' : window.location.hostname;
  switch (true) {
    case /mip(\-[a-z]+)*\.gp\.agkn\.net/.test(hostname):
    case /neuak-test(-(sso|samlsso))?\.aggregateknowledge\.com/.test(hostname):
      return urlsByEnv.qa;
    case /dashboard(-(sso|samlsso))?\.p1\.neustar\.biz/.test(hostname):
      return urlsByEnv.prod;
    case /mip(-qa)?\.mii\.agkn\.net/.test(hostname):
      return urlsByEnv.mii;
    case /mip(-qa)?\.ui\.agkn\.net/.test(hostname):
      return urlsByEnv.ui;
    case /mip(-qa)?\.idmp\.agkn\.net/.test(hostname):
      return urlsByEnv.idmp;
    case /mip\.dev\.agkn\.net/.test(hostname):
      return urlsByEnv.dev;
    default:
      // return urlsByEnv.local;
      return urlsByEnv.dev;
      // return urlsByEnv.qa;
      // return urlsByEnv.prod;
  }
})();

export default URLS;
